import { Check } from 'lucide-react'
import { ASSINATURA } from '@/utils/assinatura'
import { OLEOS_PROTOCOLO } from '@/utils/protocolosEssenciais'

// Total real do catálogo de protocolos, arredondado para baixo na dezena.
const TOTAL_OLEOS = OLEOS_PROTOCOLO.length
const OLEOS_ARREDONDADO = Math.floor(TOTAL_OLEOS / 10) * 10

const BLOCOS: { titulo: string; itens: string[] }[] = [
  {
    titulo: 'Banco de protocolos de óleos essenciais',
    itens: [
      `Mais de ${OLEOS_ARREDONDADO} óleos essenciais com ficha pronta de uso: situações de uso, modo aromático, tópico e interno, e a diluição indicada. Busque o óleo, selecione quantos quiser e copie o protocolo para enviar ao cliente pelo WhatsApp.`,
    ],
  },
  {
    titulo: 'Diagnósticos adulto e infantil',
    itens: [
      'Link personalizado para cada diagnóstico',
      'Protocolo de uso personalizado, com rotina diária',
    ],
  },
  {
    titulo: 'Calculadora de óleos',
    itens: ['Cálculo de valores, frete e parcelamento na hora do atendimento'],
  },
  {
    titulo: 'Área Empresas',
    itens: [
      'Contratos e modelos de proposta',
      'Um link exclusivo para cada empresa apresentar o diagnóstico',
      'Relatório com o resultado da equipe',
    ],
  },
  {
    titulo: 'Cursos de aromaterapia',
    itens: ['Link de inscrição próprio para acompanhar quem se inscreveu'],
  },
  {
    titulo: 'Jornada Compartilhe',
    itens: ['Plano de ação para divulgar os óleos, com mensagens prontas'],
  },
  {
    titulo: 'Jornada 12 Emoções',
    itens: ['Primeiro acesso incluso para você viver a jornada'],
  },
  {
    titulo: 'Painel de contatos',
    itens: [
      'Todos os contatos organizados, com histórico e status de cada atendimento',
      'Óleos indicados para cada pessoa',
    ],
  },
  {
    titulo: 'Material de divulgação e apoio',
    itens: [
      'Criativos e panfletos prontos para divulgar',
      'Orientações de como divulgar seu link',
      'Script de vendas automático, com mensagens prontas para copiar e enviar',
    ],
  },
  {
    titulo: 'Como usar o sistema',
    itens: ['Aulas ensinando como começar e como dar o retorno ao cliente'],
  },
]

export default function PlanosAssinatura() {
  return (
    <div className="max-w-2xl mx-auto">
      <div className="border-2 border-[#2D6A4F] rounded-2xl p-6 sm:p-8 flex flex-col bg-[#F8FBF9]">
        <h4 className="font-cormorant font-semibold text-[#2C2C2A] text-2xl mb-1">
          {ASSINATURA.titulo}
        </h4>
        <p className="text-[#5F5E5A] text-sm leading-relaxed mb-5">
          Um único acesso, com tudo o que você precisa para atender com método, organizar seus
          contatos e divulgar os óleos essenciais com profissionalismo.
        </p>

        <div className="mb-6 space-y-1">
          <p className="text-[#2C2C2A] text-3xl leading-tight">
            <span className="font-dm-sans font-semibold [font-variant-numeric:lining-nums_tabular-nums]">
              {ASSINATURA.preco}
            </span>
            <span className="text-base font-normal text-[#5F5E5A]"> por ano</span>
          </p>
          <p className="text-[#5F5E5A] text-sm [font-variant-numeric:lining-nums_tabular-nums]">
            À vista ou {ASSINATURA.parcelado}
          </p>
        </div>

        <div className="space-y-5 mb-7 flex-1">
          {BLOCOS.map((bloco) => (
            <div key={bloco.titulo}>
              <p className="font-medium text-[#2D6A4F] text-sm mb-1.5">{bloco.titulo}</p>
              <ul className="space-y-1.5">
                {bloco.itens.map((item) => (
                  <li key={item} className="flex items-start gap-2 text-sm text-[#2C2C2A]">
                    <Check
                      className="w-4 h-4 text-[#2D6A4F] shrink-0 mt-0.5"
                      strokeWidth={2.5}
                    />
                    <span className="leading-relaxed">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-auto">
          <a
            href={ASSINATURA.link}
            target="_blank"
            rel="noopener noreferrer"
            className="block text-center min-h-[48px] leading-[48px] rounded-full bg-[#2D6A4F] text-white font-semibold text-sm sm:text-base hover:bg-opacity-90 transition-colors"
          >
            {ASSINATURA.botao}
          </a>
        </div>
      </div>
    </div>
  )
}
